import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors as configSelectors } from '../../infrastructure/config';
import GDPRQuestionPage from './components/GDPRQuestionPage';
import { dataCaptureSelectors, saveGDPRForm } from '../../store/dataCapture';
import { setCurrentPage, getBackRoute } from '../routUtils/routingUtils';
import { GDPR_PAGE_KEY } from '../routUtils/routingConstants';
import { selectors as caseSelectors } from '../../infrastructure/cases';

class GDPRQuestion extends Component {
  constructor(props) {
    super(props);
    setCurrentPage(GDPR_PAGE_KEY);
    this.businessBack = this.businessBack.bind(this);
  }
  businessBack() {
    this.props.history.push(getBackRoute());
  }

  render() {
    const {
      bankId,
      brandId,
      saveGDPRForm,
      getBusinessData,
      businessId,
      marketingLoader,
      businessUpdateId,
      caseId,
      caseType
    } = this.props;

    return (
      <GDPRQuestionPage
        brandId={brandId}
        bankId={bankId}
        saveGDPRForm={saveGDPRForm}
        caseId={caseId}
        caseType={caseType}
        backClick={this.businessBack}
        getBusinessData={getBusinessData}
        businessId={businessId}
        marketingLoader={marketingLoader}
        businessUpdateId={businessUpdateId}
      />
    );
  }
}

GDPRQuestion.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveGDPRForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveGDPRForm
};

const mapStateToProps = (state) => ({
  brandId: configSelectors.brandId(state),
  bankId: configSelectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state),
  businessId: dataCaptureSelectors.businessId(state),
  marketingLoader: dataCaptureSelectors.marketingLoader(state),
  businessUpdateId: configSelectors.business_uuid(state) || caseSelectors.business_uuid(state),
  caseId: configSelectors.getCaseId(state),
  caseType: caseSelectors.getCaseType(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GDPRQuestion);
